/**
 * -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
 * Sectors - Mugombwa 
 * -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
 */
module.exports = {
  "Baziro": ["Banzankuru", "Gitungwa", "Nyabinyenga", "Nyagatovu", "Nyamirama", "Nyarukeri", "Nyesumo"],
  "Kibayi": ["Agakanka", "Akarutsibuka", "Akashyamba", "Akabuga", "Rinda", "Rwahambi", "Udukoni"],
  "Kibu": ["Agasharu", "Akabugabo", "Akagashuma", "Mushongi", "Rurenge"],
  "Mugombwa": ["Agasharu", "Akagarama", "Akarambo", "Bishya", "Impinga", "Migina"],
  "Mukomacara": ["Agakomansyo", "Akanyamirama", "Akarangabo", "Akatare", "Gitarama", "Kabuye", "Nyabisonga", "Nyarusange", "Umukungu"]
};